const PROFILE_FIELD_MAPPINGS = [
  { settingsKey: "name_for_coach", propertyKey: "nameForCoach" },
  { settingsKey: "surname_for_coach", propertyKey: "surnameForCoach" },
  { settingsKey: "notes", propertyKey: "notes" },
  { settingsKey: "phone", propertyKey: "phone" },
  { settingsKey: "gender", propertyKey: "gender" },
  { settingsKey: "profile_squat", propertyKey: "profileSquat" },
  { settingsKey: "profile_bench_press", propertyKey: "profileBenchPress" },
  { settingsKey: "profile_deadlift", propertyKey: "profileDeadlift" },
];

const isValidClient = (client) => !!client && typeof client === "object";

const areDifferent = (left, right) => left !== right;

export const syncClientProfileDraftWithPersistedData = (client) => {
  if (!isValidClient(client)) {
    return;
  }

  PROFILE_FIELD_MAPPINGS.forEach(({ settingsKey, propertyKey }) => {
    client.setSettings(settingsKey, client[propertyKey]);
  });
};

export const hasClientProfileUnsavedChanges = (client) => {
  if (!isValidClient(client)) {
    return false;
  }

  const settings = client.clientSettings ?? {};
  return PROFILE_FIELD_MAPPINGS.some(({ settingsKey, propertyKey }) =>
    areDifferent(settings[settingsKey], client[propertyKey])
  );
};

export const saveClientProfileDraft = (client) => {
  if (!isValidClient(client) || client.isOffline) {
    return false;
  }

  const settings = client.clientSettings ?? {};
  let hasChanges = false;

  PROFILE_FIELD_MAPPINGS.forEach(({ settingsKey, propertyKey }) => {
    if (areDifferent(settings[settingsKey], client[propertyKey])) {
      client.setProperty(propertyKey, settings[settingsKey]);
      hasChanges = true;
    }
  });

  if (hasChanges) {
    client.saveClientProfile(settings);
  }

  return hasChanges;
};

export const discardClientProfileDraft = (client) => {
  syncClientProfileDraftWithPersistedData(client);
};

export { PROFILE_FIELD_MAPPINGS };
